import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  NamingConventionBuilder,
  type NamingConventionValue,
} from "@/components/shared/NamingConventionBuilder";

interface NamingConventionData {
  tags: string[];
  separator: string;
  custom_separator?: string;
  custom_tags?: string[];
}

interface SetupNamingConventionProps {
  data: { naming_convention: NamingConventionData | null };
  onChange: (data: { naming_convention: NamingConventionData }) => void;
}

export function SetupNamingConvention({ data, onChange }: SetupNamingConventionProps) {
  const current = data.naming_convention;

  const value: NamingConventionValue = {
    tags: current?.tags ?? [],
    separator: current?.separator ?? "_",
    custom_separator: current?.custom_separator ?? "",
    custom_tags: current?.custom_tags ?? [],
  };

  const handleChange = (next: NamingConventionValue) => {
    onChange({ naming_convention: next });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Ad Naming Convention</CardTitle>
        <CardDescription>Build a naming pattern for your ads</CardDescription>
      </CardHeader>
      <CardContent>
        <NamingConventionBuilder value={value} onChange={handleChange} />
      </CardContent>
    </Card>
  );
}
